import { Link, LinkProps } from '@remix-run/react';
import { motion } from 'framer-motion';
import { FC } from 'react';
import { useHover } from 'react-use';
import { MonetaryAmount } from '../../generated/graphql';
import { displayMonetaryAmount } from '../../util';
import { Icon } from './Icon';

interface IncomeAndSpendingButtonProps extends Pick<LinkProps, 'to' | 'onClick'> {
  label: string;
  value?: MonetaryAmount | null;
  linkState?: { viewIndex: number };
}

export const IncomeAndSpendingButton: FC<IncomeAndSpendingButtonProps> = ({ to, label, value, onClick, linkState }) => {
  const [hoverable] = useHover((hovered) => (
    <Link onClick={onClick} to={to} state={linkState}>
      <button
        className={'IncomeAndSpendingButton flex h-20 w-full items-center justify-between rounded-2xl bg-darkMode-gray-medium/[0.16] pl-4 pr-3 hover:bg-palette-600/20 '}
      >
        <div className="text-start">
          <p className="font-medium">{label}</p>
          <div className="text-3xl">
            {value?.value !== undefined && value.value !== null && <span className="font-medium">$</span>}
            <span className="max-w-[161px] overflow-hidden text-ellipsis font-bold text-white">
              {displayMonetaryAmount(value, {
                zeroIsDash: false,
                nullishIsDash: true,
                withoutDollarSign: true,
              })}
            </span>
          </div>
        </div>
        <motion.div className="ml-2 self-center" animate={hovered ? { x: 2 } : { x: 0 }}>
          <Icon icon={'chevronRight'} className={'text-palette-600'} />
        </motion.div>
      </button>
    </Link>
  ));

  return hoverable;
};
